import React, { useState } from 'react';
import Nav from './Nav';
import Footer from './Footer';
import './Endemic.css';

export default function Endemic() {
    const [selectedImage, setSelectedImage] = useState(null);
    const [expandedSpecies, setExpandedSpecies] = useState(null);

    const endemicGroups = {
        'Araneae': [
            {
                name: 'Brachythele kosovarica',
                author: 'Geci & Sherwood, 2025',
                description: 'Është një lloj i ri i merimangave, i përshkruar nga fshati Veriq në komunën e Istogut. Lloji është gjithashtu i njohur edhe në tri lokalitete të tjera: Mitrovicë, Pejë, Prizren (Geci et al., 2025).',
                image: 'Brachythele kosovarica.jpg'
            },
            {
                name: 'Eratigena mirusha',
                author: 'Geci, Naumova & Ibrahimi, 2025',
                description: 'Lloji është përshkruar nga një livadh në afërsi të një miniere të kromit në fshatin Panorc, në Malin Koznik. Lloji preferon habitate më të lagështa, duke marrë parasysh se zona në të cilin është gjetur karakterizohet me thatësi gjatë verës dhe lagështi gjatë pjesës tjetër të vitit. Emri i llojit i referohet zonës në të cilën është zbuluar, e cila njihet për Ujëvarat e Mirushës (Geci et al., 2025).',
                image: 'Eratigena mirusha.png'
            },
            {
                name: 'Harpactea dardanica',
                author: 'Geci & Zamani, 2025',
                description: 'Lloji është përshkruar nga një pyll i ahut në Bjeshkët e Nemuna. Emri i llojit është një mbiemër i latinizuar që i referohet Mbretërisë së lashtë të Dardanisë (shekulli IV p.e.s. – 28 p.e.s.), e cila kishte qendër territorin e Kosovës së sotme (Geci et al., 2025).',
                image: 'Harpacteae dardanica.jpg'
            },
            {
                name: 'Nemesia dukagjinica',
                author: 'Geci & Sherwood, 2025',
                description: 'Është përshkruar gjithashtu nga fshati Veriq, në komunën e Istogut. Deri tash është i njohur vetëm në lokalitetin nga i cili është zbular. Emri i llojit i referohet rrafshit të Dukagjinit, që ndodhet në pjesën perëndimore të Kosovës (Geci et al., 2025).',
                image: 'Nemesia dukagjinica.jpg'
            }
        ],
        'Trichoptera': [
            {
                name: 'Drusus dardanicus',
                author: 'Ibrahimi, Kučinić & Vitecek, 2015',
                description: 'Stadi larvor i këtij lloji është tregues i ujërave të pastra. Faza adulte paraqitet në periudhën maj - gusht. Si adult jeton për disa ditë deri në disa javë në afërsi të brigjeve të përroskës apo lumit, ku ka jetuar si larvë. Në Kosovë është konstatuar në vetëm 1 lokalitet - në një përroskë në fshatin Bollosicë. Është vlerësuar si lloj skajshmërisht i rrezikuar për shkak të uljes së vazhdueshme të popullatës si rezultat i ndotjes (Ibrahimi et al., 2015; 2019).',
                image: 'Drusus_dardanicus.jpg'
            },
            {
                name: 'Drusus sharrensis',
                author: 'Ibrahimi, Previšić & Vitecek, 2016',
                description: 'Madhësia e krahëve të përparmë të këtij lloji është prej 7 deri në 9 mm. Faza larvore është treguese e ujërave të pastra. Lloji është përshkruar nga Malet e Sharrit nga edhe është emëruar. Gjendet kryesisht në zonat burimore dhe në rrjedhat e epërme të përroskave malore. Është vlerësuar në kategorinë: Skajshmërisht i rrezikuar (Ibrahimi et al., 2016; 2019).',
                image: 'Drusus_sharrensis_.jpg'
            },
            {
                name: 'Potamophylax coronavirus',
                author: 'Ibrahimi, Bilalli & Vitecek, 2021',
                description: 'Është lloj i përshkruar nga Bjeshkët e Nemuna, të dy lokalitetet në të cilat është mbledhur lloji janë në lartësi mbidetare mbi 2000m. Epiteti i llojit coronavirus lidhet me pandeminë globale të shkaktuar nga (SARS-CoV-2), e cila filloi në vitin 2020. Studimi është shkruar gjatë periudhës së karantinës për shkak të pandemisë. Përveç kësaj, epiteti simbolizon edhe një pandemi tjetër të heshtur që po ndodh tek organizmat e ujërave të ëmbla në lumenjtë e Kosovës, për shkak të ndotjes dhe degradimit të habitatit të tyre, duke përfshirë veçanërisht aktivitetin e shtuar të hidrocentraleve të keq menaxhuara (Ibrahimi et al., 2021).',
                image: 'Potamophylax coronavirus.jpg'
            },
            {
                name: 'Potamophylax humoinsapiens',
                author: 'Ibrahimi & Bilalli, 2023',
                description: 'Është lloj i përshkruar nga Malet e Sharrit. Është gjetur në tri lokalitete, degë të lumit Lepenc. Epiteti i llojit është një kombinim i dy fjalëve latine, "humo", që në shqip do të thotë "të mbulosh me tokë" dhe "insapiens" që do të thotë "i pamend" dhe i referohet trajtimit të pamend dhe të pakujdesshëm të habitatit të llojit të ri, i cili është degraduar shumë gjatë viteve të fundit nga hidrocentralet dhe aktivitetet e tjera (Ibrahimi et al., 2023).',
                image: 'Potamophylax humoinsapiens.jpg'
            },
            {
                name: 'Potamophylax kosovaensis',
                author: 'Ibrahimi & Bilalli, 2024',
                description: 'Lloji i ri gjendet ekskluzivisht në zonat burimore të të dy degëve në lumin Kaçandoll dhe lumin Llap. Është lloj endemik i Malit Kopaonik (Ibrahimi et al., 2024).',
                image: 'Potamophylax kosovaensis.jpg'
            },
            {
                name: 'Rhyacophila siparantum',
                author: 'Ibrahimi, Bilalli & Kučinić, 2021',
                description: 'Lloji u gjet në një lokalitet të vetëm në një përroskë në Bogë në Malin e Rugovës, i cili është pjesë e Bjeshkëve të Nemuna. Epiteti i këtij lloji i referohet emrit të vjetër të qytetit të Pejës në pjesën perëndimore të Kosovës, i cili ndodhet rrëzë maleve të Rugovës ku u gjet edhe lloji i ri. Habitatet e vogla të burimeve dhe përrenjve, si lokaliteti tipik i këtij lloji janë degraduar rëndë gjatë viteve të fundit në Bjeshkët e Nemuna (Ibrahimi et al., 2021).',
                image: 'Rhyacophila siparantum.jpg'
            },
            {
                name: 'Tinodes lumbardhi',
                author: 'Ibrahimi, Bilalli & Musliu, 2025',
                description: 'Është lloj i përshkruar nga Lumbardhi i Deçanit në Bjeshkët e Nemuna. Lloji u gjet në një përroskë të vogël dhe të mbuluar me hije, me rrjedhë minimale të ujit. Përroska ishte e rrethuar me bimësi të dendur dhe të lartë duke krijuar një mjedis të freskët dhe me ndriçim të dobët. Rezultatet tregojnë se rrjedha kryesore e lumit Lumbardhi i Deçanit është shumë e degraduar, kryesisht për shkak të ndërtimit të hidrocentraleve (Ibrahimi et al., 2025).',
                image: 'Tinodes lumbardhi.jpg'
            }
        ],
        'Gastropoda': [
            {
                name: 'Belgrandiella bumasta',
                author: 'Schütt, 1960',
                description: 'Guaska është e vogël (gjatësia 1.8 - 2.0 mm, gjerësia 1.0-1.2 mm), me ngjyrë kah e bardha, rrethore cilindrike, me maje të topitur. Apertura në formë trekëndëshi me maje të rrethuar. Ky lloj është i njohur vetëm nga Gryka e Rugovës në afërsi të Pejës. Për shkak të jetës së tij të fshehur është e pritshme se do të zbulohen në të ardhmen edhe nënpopullata dhe lokalitete të tjera të këtij lloji. Lloji është vlerësuar si i Cenuar (Ibrahimi et al., 2019).',
                image: 'Belgrandiella bumasta.png'
            },
            {
                name: 'Bythinella istoka',
                author: 'Glöer & Pešić, 2014',
                description: 'Guaska është e vogël (gjatësia 2.7 - 2.8 mm, gjerësia 1.5–1.6 mm), me ngjyrë kah e bardha, cilindrike, me majë të topitur dhe umbilikus të mbyllur. Sipërfaqja është e mëndafshtë dhe e shtresëzuar imët, apertura vezake, peristoma e trashur në kolumellë. Është lloj tipik i burimeve karstike. Ky lloj është i njohur vetëm nga një burim i madh karstik në afërsi të Malit Mokna, në afërsi të Istogut dhe është vlerësuar si i Cenuar (Ibrahimi et al., 2019).',
                image: 'Bythinella istoka.png'
            },
            {
                name: 'Terranigra kosovica',
                author: 'Radoman, 1978',
                description: 'Guaska është e vogël (gjatësia 1.6 - 2.2 mm, gjerësia 0.8-1.1 mm), e pangjyrë, forma ovoide-cilindrike me maje të shtypur dhe dredha lehtas të fryra. Apertura është ovoide, rrethore në maje, peristoma e hollë, dhe umbilikusi në formë të prerë apo i mbyllur. Ky lloj është i njohur nga vetëm 4 lokalitete në Kosovë: Nerodime e Epërme (2), Pridvoricë, Caralevë (Ibrahimi et al., 2019).',
                image: 'Terranigra kosovica.png'
            }
        ],
        'Diplopoda': [
            {
                name: 'Brachydesmus jalzici',
                author: 'Mrsic, 1988',
                description: 'Është një lloj endemik me lokalitetin tipor në Kosovë (Shpella e Dushit në Klinë). I takon grupit vermosanus, i cili ka disa lloje endemike në rajonin karstik dinarik të Ballkanit. Gjatësia trupore është prej 10-12.5 mm, me 19 segmente trupore. Është vlerësuar si lloj i Cenuar (Ibrahimi et al., 2019).',
                image: 'Brachydesmus jalzici.png'
            }
        ],
        'Coleoptera': [
            {
                name: 'Deltomerus (Deltomerus) nopcsai',
                author: 'Csiki, 1940',
                description: 'Lloj me madhësi mesatare (9-12 mm). Është lloj predator, që aktivisht e kërkon prenë edhe si adult, por edhe si larvë. Është regjistruar në habitate alpine vetëm në majat më të larta në malet e Koprivnikut dhe paraqet lloj stenoendemik për Kosovën. Lloji është vlerësuar si i Cenuar (Ibrahimi et al., 2019).',
                image: null
            },
            {
                name: 'Pavicevicia comottiorum',
                author: 'Giachino, 2006',
                description: 'Është lloj me madhësi shumë të vogël (2 - 2.7 mm). Jeton në mjedise nëntokësore, duke u ushqyer me mbetje të trupave të kafshëve të tjera. Trupi është i përshtatur mirë për të jetuar në mjedise nëntokësore: mungesë e tërësishme e syve, antena shumë mirë të zhvilluara dhe mungesë e pigmentimit të trupit. Përhapja e këtij lloji është e kufizuar në vetëm një shpellë në Rugovë. Ky lloj është vlerësuar si: I Cenuar (Ibrahimi et al., 2019).',
                image: null
            },
            {
                name: 'Pavicevicia pretneri',
                author: 'Perreau, 2008',
                description: 'Është lloj me madhësi shumë të vogël (1.9 - 2.3 mm). Sikurse lloji paraprak jeton në mjedise nëntokësore, duke u ushqyer me mbetje të kafshëve të tjera. Trupi është përshtatur për të jetuar në mjedise nëntokësore dhe është i vlerësuar si: i Cenuar (Ibrahimi et al., 2019).',
                image: null
            }
        ],
        'Isopoda': [
            {
                name: 'Alpioniscus metohicus',
                author: 'Pljakic, 1971',
                description: 'Është lloj endemik me përhapje të ngushtë. Gjatësia e trupit të mashkullit varion prej 4.6 deri në 7.5 mm, kurse femrat janë pak më të mëdha, prej 5.5 deri në 7.7 mm. Ngjyrat e trupit është e bardhë pa pigment okular. Përhapja e tij është kufizuar në vetëm një shpellë, në Radavc. Është vlerësuar në kategorinë: I Cenuar (Ibrahimi et al., 2019).',
                image: null
            }
        ]
    };

    const handleImageClick = (image) => {
        setSelectedImage(image);
    };

    const closeModal = () => {
        setSelectedImage(null);
    };

    const toggleExpanded = (speciesName) => {
        setExpandedSpecies(expandedSpecies === speciesName ? null : speciesName);
    };

    const groupNames = {
        'Araneae': 'Merimangat (Araneae)',
        'Trichoptera': 'Insektet Ujore (Trichoptera)',
        'Gastropoda': 'Kërmij (Gastropoda)',
        'Diplopoda': 'Shumkëmbëshat (Diplopoda)',
        'Coleoptera': 'Brumbujt (Coleoptera)',
        'Isopoda': 'Izopodët (Isopoda)'
    };

    return (
        <div className="endemic-page">
            <Nav />
            <div className="endemic-content">
                <div className="endemic-hero">
                    <div className="hero-overlay"></div>
                    <div className="hero-content">
                        <h1>Llojet Endemike të Kosovës</h1>
                        <div className="hero-divider"></div>
                        <p className="hero-subtitle">
                            Thesari Biologjik i Kosovës - Lloje që nuk ekzistojnë askund tjetër në botë
                        </p>
                        <p className="hero-description">
                            Llojet endemike janë ato lloje që gjenden vetëm në një zonë të caktuar gjeografike dhe 
                            asgjëkundi tjetër në botë. Kosova ka disa lloje endemike të kafshëve, veçanërisht insekte 
                            ujore dhe merimanga, të cilat janë zbuluar në vitet e fundit dhe që tregojnë biodiversitetin 
                            e pasur të vendit tonë. Këto lloje përfaqësojnë thesarin biologjik të Kosovës dhe kërkojnë 
                            mbrojtje të veçantë për ruajtjen e tyre për brezat e ardhshëm.
                        </p>
                    </div>
                </div>

                {Object.entries(endemicGroups).map(([groupKey, species]) => (
                    <div key={groupKey} className="endemic-group">
                        <h2 className="group-title">{groupNames[groupKey]}</h2>
                        <div className="endemic-grid">
                            {species.map((sp, index) => {
                                let imageSrc = null;
                                
                                // Try to load image if it exists
                                if (sp.image) {
                                    try {
                                        imageSrc = require(`../pics/endermicPics/${sp.image}`);
                                    } catch (error) {
                                        console.error(`Image not found for ${sp.name}`, error);
                                    }
                                }

                                const isExpanded = expandedSpecies === sp.name;
                                const shortDescription = sp.description.length > 150 
                                    ? sp.description.substring(0, 150) + '...' 
                                    : sp.description;

                                return (
                                    <div key={index} className="endemic-card">
                                        <div className="endemic-image-container">
                                            {imageSrc ? (
                                                <img 
                                                    src={imageSrc} 
                                                    alt={sp.name}
                                                    onClick={() => handleImageClick(imageSrc)}
                                                    className="endemic-image"
                                                />
                                            ) : (
                                                <div className="endemic-no-image">
                                                    <svg 
                                                        className="endemic-placeholder-icon" 
                                                        viewBox="0 0 24 24" 
                                                        fill="none" 
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path 
                                                            d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" 
                                                            stroke="currentColor" 
                                                            strokeWidth="1.5"
                                                        />
                                                        <path 
                                                            d="M12 7V13M12 16H12.01" 
                                                            stroke="currentColor" 
                                                            strokeWidth="2" 
                                                            strokeLinecap="round"
                                                        />
                                                        <circle cx="12" cy="12" r="8" fill="currentColor" opacity="0.1"/>
                                                    </svg>
                                                    <p className="endemic-no-image-text">Fotografia nuk është në dispozicion</p>
                                                </div>
                                            )}
                                        </div>
                                        <div className="endemic-info">
                                            <h3 className="endemic-name">{sp.name}</h3>
                                            <p className="endemic-author">{sp.author}</p>
                                            <p className="endemic-description">
                                                {isExpanded ? sp.description : shortDescription}
                                            </p>
                                            {sp.description.length > 150 && (
                                                <button 
                                                    className="read-more-btn"
                                                    onClick={() => toggleExpanded(sp.name)}
                                                >
                                                    {isExpanded ? 'Shfaq më pak' : 'Lexo më shumë'}
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                ))}

                <div className="endemic-footer-info">
                    <h2>Mbrojtja e Llojeve Endemike</h2>
                    <p>
                        Këto lloje janë jashtëzakonisht të rëndësishme për shkencën dhe mjedisin sepse 
                        nuk ekzistojnë askund tjetër në planet. Humbja e habitateve të tyre do të thotë 
                        zhdukje përgjithmonë nga bota. Prandaj, mbrojtja e lumenjve, burimeve, shpellave 
                        dhe ekosistemeve tjera natyrore është thelbësore për mbijetesën e këtyre llojeve.
                    </p>
                    <p>
                        Shumë nga këto lloje janë të rrezikuara nga aktivitetet njerëzore, veçanërisht 
                        nga ndërtimi i hidrocentraleve, ndotja e ujërave, dhe shkatërrimi i habitateve natyrore. 
                        Është përgjegjësia jonë të mbrojmë këto lloje unike për brezat e ardhshëm.
                    </p>
                </div>
            </div>
            <Footer />

            {/* Modal for enlarged image */}
            {selectedImage && (
                <div className="endemic-modal" onClick={closeModal}>
                    <img src={selectedImage} alt="Selected endemic species" className="endemic-modal-image" />
                </div>
            )}
        </div>
    );
}

